module.exports = __webpack_public_path__ + "img/33.b25ec0a8.png";